var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "23px",
    viewBox: "0 0 23 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Path") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "landing-page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Landing_final_hover-on-after",
    transform: "translate(-747.000000, -2550.000000)",
    stroke: "#FF8E46",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M759.621756,2552.67027 L762.059985,2557.92854 L766.812868,2557.92854 C767.303969,2557.90928 767.754293,2558.20042 767.938292,2558.65616 C768.122292,2559.11189 768.000347,2559.63409 767.633532,2559.96119 L763.514367,2564.02174 L765.795751,2569.27051 C766.003321,2569.76295 765.872646,2570.33296 765.471293,2570.6858 C765.069941,2571.03865 764.487888,2571.09523 764.026094,2570.82628 L758.511165,2567.71948 L752.994652,2570.82628 C752.532859,2571.09523 751.950806,2571.03865 751.549453,2570.6858 C751.148101,2570.33296 751.017426,2569.76295 751.224996,2569.27051 L753.50638,2564.02174 L749.387214,2559.96119 C749.020565,2559.63632 748.89683,2559.11651 749.077785,2558.66128 C749.25874,2558.20605 749.705576,2557.91304 750.195204,2557.92854 L754.940166,2557.92854 L757.383148,2552.66552 C757.60397,2552.25195 758.035053,2551.99406 758.50388,2551.99505 C758.972708,2551.99605 759.402692,2552.25577 759.621756,2552.67027 Z",
    id: "Path"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar1);
export default __webpack_public_path__ + "static/media/star1.a9288ba918970e2426b24912f3acdf72.svg";
export { ForwardRef as ReactComponent };